<template>
    <blank-layout>


        <div class="-mt-6 flex flex-grow flex-col">

            <div class="flex flex-col md:flex-row w-full flex-grow">



                <div class="flex flex-grow bg-white flex-col justify-center items-center">


                    <div class="flex flex-col w-full max-w-xl">


                        <div>
                            <h3 class="text-blue-500 flex flex-row justify-center items-center">
                                <span class="text-primary font-bold text-4xl mt-2 uppercase" v-if="false">{{ app_name }}
                                    +</span> <img src="/img/helpscout-logo.svg" width="200" alt="Helpscout Logo"
                                    class="align-center ml-0 mt-1" />
                            </h3>
                        </div>
                        <h1 class="text-center text-2xl mt-3 text-gray-700">{{ app_name }} request link created</h1>

                        <p>&nbsp;</p>

                        <a :href="back_url" title="Continue" class="border-4 border-b-0 border-indigo-100 rounded-t-md">
                            <img src="/img/helpscout-draft.png" alt="Helpscout Draft"
                                class="align-center w-full rounded-t overflow-hidden" />
                        </a>

                        <div class="rounded-b-md bg-indigo-100 p-6 border-4 border-t-0 border-indigo-100">
                            <p class="mt-5 text-center">Your request has been added as a new <strong>Draft</strong> into
                                your Helpscout mailbox: now you need to edit it, and hit <strong>Send Reply</strong>
                                when ready!</p>
                            <p class="mt-5 text-center">
                                <jet-button class="mx-auto bg-blue-500 text-white hover:bg-blue-400"
                                    @click.prevent="go_back">
                                    Continue <vue-feather type="arrow-right" class="h-5 w-5 ml-2" />
                                </jet-button>
                            </p>
                        </div>

                        <div class="mt-10 rounded-md bg-indigo-100 p-6" v-if="false">
                            <textarea v-model="form.text_pre" placeholder="Add a message (optionnal)"
                                class="w-full h-15 rounded bg-gray-100 mb-10"></textarea>

                            <label for="text_link">Recording link label
                                <input type="text" v-model="form.text_link" id="text_link"
                                    :placeholder="text_link_default" class="w-full rounded" />
                            </label>

                            <!-- <p class="text-center">Please refresh your Helpscout mailbox to start using Zest.</p> -->

                            <!-- <textarea v-model="form.text_post"
                                placeholder="Add text after the link (optionnal)"
                                class="w-full h-15 rounded bg-gray-100 mt-10"></textarea> -->

                        </div>

                        <div class="mt-10" v-if="false">
                            <jet-button class="w-full bg-blue-500 text-white hover:bg-blue-400 text-base"
                                :class="{ 'opacity-25': form.processing }" :disabled="form.processing"
                                @click.prevent="send_request">
                                Send Request <vue-feather type="arrow-right" class="h-5 w-5 ml-2" />
                            </jet-button>
                        </div>


                    </div>


                </div>


            </div>


        </div>

    </blank-layout>
</template>

<script>

import BlankLayout from "@/Layouts/BlankLayout"
import JetButton from '@/Jetstream/Button'

export default {
    props: [
        'customer_id',
        'customer_name',
        'customer_email',
        'mailbox_id',
        'ticket_id',
        'integration_id',
        'back_url'
    ],


    components: {
        BlankLayout, JetButton,

    },
    data() {
        return {
            form: this.$inertia.form({
                text_pre: "",
                text_link: "Click here to record your screen",
                integration_id: this.integration_id,
                customer_id: this.customer_id,
                customer_name: this.customer_name,
                customer_email: this.customer_email,
                mailbox_id: this.mailbox_id,
                ticket_id: this.ticket_id,
            }),
            text_link_default: "Click here to record your screen",
            is_complete: false,
            app_name: this.$page.props.app_name
        }
    },
    created() {

    },
    beforeUnmount() {

    },
    mounted() {
        console.log(this.back_url)
    },
    computed: {

    },
    methods: {
        go_back: function () {
            window.location = this.back_url;
        },
        send_request: function () {
            let url = this.$page.props.api_url + '/v1/helpscout/request'
            // if (this.form.text_link == "") {
            //     this.form.text_link = this.text_link_default
            // }
            this.form.post(url, {
                //errorBag: 'submitSignup',
                preserveScroll: true,
                onSuccess: () => {
                    console.log("DONE", this.form)
                    this.is_complete = true
                },
                onError: () => {
                    console.error("An error occured", this.form.errors)
                }
            })

            /*
            var params = {
                integration_id: this.integration_id,
            };
            axios.post(url, params)
            .then(response => {
                //console.log(response.data);
                let options = {
                    type: "default",
                    timeout: 2500,
                    position: "top-right",
                    hideProgressBar: false,
                }
                this.$moshaToast("Setting updated", options)
            })
            .catch(e => {
                console.error(e);
            }); */
        }
    }
}
</script>
